var exports = {
  "c": "toolFooterSlot__eF9ake",
};

module.exports = exports;
